// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\r\n.modal-element {\r\n    height: 50px;\r\n    margin: 20px;\r\n}\r\n  ", "",{"version":3,"sources":["webpack://src/styles/App.css"],"names":[],"mappings":";AACA;IACI,YAAY;IACZ,YAAY;AAChB","sourcesContent":["\r\n.modal-element {\r\n    height: 50px;\r\n    margin: 20px;\r\n}\r\n  "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
